import { render, staticRenderFns } from "./widget-nav.vue?vue&type=template&id=9d79f9f6"
import script from "./widget-nav.vue?vue&type=script&lang=js"
export * from "./widget-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports